module.exports = new Promise(async (resolve, reject) => {
  try {
    const module = await import('undefined/assets/remoteEntry.js?t=1792725254924');
    resolve(module);
  } catch (error) {
    // console.error('Failed to load remote:', error);
    resolve(null);
  }
})
;